import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import { styled } from '@mui/system';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { AppBarIcon } from 'components/AppBar';
import { PrimaryCta } from 'components/Buttons';
import { StyledBottomNavigation } from 'catering/components/StyledBottomNavigation';

import { HEADER } from 'styles/constants/appearanceSectionNames';
import { getHeaderLinkHoverColor } from 'styles/helpers/getThemeStyles';
import { useIsMobile } from 'styles/hooks/mediaQueries';

const StyledLabel = styled(Typography)(({ theme }) => {
  const hoverStyles = {
    color: getHeaderLinkHoverColor(theme)
  };
  return {
    padding: '6px 0',
    color: theme.palette.header.accent.main,
    fontWeight: theme.fonts.medium,
    fontSize: 16,
    '&:hover': hoverStyles
  };
});

const Label = styled('span')({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between'
});

function OpenCartButton({ cart: { quantity, subtotal }, onClick }) {
  const isMobile = useIsMobile();
  const theme = useTheme();
  const styles = { variant: HEADER };
  return (
    <>
      {isMobile ? (
        <StyledBottomNavigation>
          <PrimaryCta
            dataTestId="cart-bottom-nav-button"
            fullWidth
            handleClick={onClick}
            label={
              <Label>
                <span>{quantity}</span>
                <span>View Cart</span>
                <span>${subtotal}</span>
              </Label>
            }
          />
        </StyledBottomNavigation>
      ) : (
        <Button
          data-testid="cart-icon-text-button"
          onClick={onClick}
          size="large"
          startIcon={<AppBarIcon icon="cart" />}
          sx={{
            '& .MuiTypography-root': {
              textTransform: 'uppercase'
            },
            '& .MuiSvgIcon-root': {
              fill: theme.palette.white
            }
          }}
        >
          <StyledLabel {...styles}>
            {`${quantity} ${quantity > 1 ? 'items' : 'item'}`}
          </StyledLabel>
        </Button>
      )}
    </>
  );
}

OpenCartButton.propTypes = {
  cart: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired
};

export default OpenCartButton;
